<template xmlns:v-clipboard="http://www.w3.org/1999/xhtml"
          xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <!--  素材管理->图片库-->
  <base-page-component :has-back="false" :has-nav="false" nav-title="图片库">
    <div style="background-color: #F4F8FF;height: calc(100% - 0px)">
      <div class="bg-white m-auto">
        <div class="flex a-center h-60 m-h-25">
          <Button @click="groupManager.show = true" class="m-r-10" type="primary">分类管理</Button>
          <Button @click="toUpload" class="m-r-10" type="primary">上传图片</Button>
          <up-load-image @uploadSuccess="uploadCoverImageSuccess"
                         @uploadprogress="uploadCoverImageProgress"
                         @uploadstart="uploadCoverImageStart"
                         accept="image/*"
                         multiple
                         picurl="common/desc/">
            <template v-slot:tip>
              <Button class="m-r-10" type="primary">批量导入</Button>
            </template>
          </up-load-image>

          <class-choose-widget :gutter="10" :srcType="6" @dataChange="onClassGroupChange"
                               leftPlaceholder="图片分类"
                               rightPlaceholder="图片分组"
                               style="width: 300px;">

          </class-choose-widget>
          <Button class="m-l-15" type="primary"
                  v-clipboard:copy="objChange.linkurl"
                  v-clipboard:error="onError"
                  v-clipboard:success="copy">复制链接
          </Button>
          <Input class="m-l-15" placeholder="图片名称" style="width: 240px" v-model="title"/>
          <Button @click="onSearchClick" class="m-l-15">搜索</Button>
          <div class="flex flex-1  h-full a-center j-end">
            <Button @click="delMulti" class="m-l-15" type="">批量删除</Button>
          </div>
        </div>

        <div class="">
          <!--          <Table :columns="columns" :data="dataList" :height="tableHeight" ref="table">-->
          <!--            <template v-slot:preview="{row,index}">-->
          <!--              <div class="flex a-center j-center">-->
          <!--                <img @click="preview(row)" class="w-40 h-40 p-8" src="../../../assets/common/ic-preview@2x.png"-->
          <!--                     style="cursor: pointer;">-->
          <!--              </div>-->
          <!--            </template>-->

          <!--            <template v-slot:copy="{row,index}">-->
          <!--              <Tooltip content="复制">-->
          <!--                <div class="flex a-center">-->
          <!--                  <div class=" icon-copy fs-20 m-l-5" style="color: #1472FF;cursor: pointer;"-->
          <!--                       v-clipboard:copy="row.linkurl"-->
          <!--                       v-clipboard:error="onError"-->
          <!--                       v-clipboard:success="copy"/>-->
          <!--                </div>-->
          <!--              </Tooltip>-->
          <!--            </template>-->

          <!--            <template v-slot:link="{row,index}">-->
          <!--              <div class="flex a-center j-center">-->
          <!--                {{ row.url }}-->
          <!--              </div>-->
          <!--            </template>-->

          <!--            <template v-slot:operation="{row,index}">-->
          <!--              <div class="flex a-center j-center">-->
          <!--                <span @click="toEditPic(row)" class="m-r-20"-->
          <!--                      style="cursor: pointer;color: #3B80FF">编辑</span>-->
          <!--                <span @click="delItem(row)"-->
          <!--                      style="cursor: pointer;color: red">删除</span>-->
          <!--              </div>-->
          <!--            </template>-->
          <!--          </Table>-->

          <div
            :style="{height:tableHeight + 'px'}"
            class="list-container scrollbar  o-y-auto m-l-10"
          >
            <!--列表数据-->
            <ratio-div :key="index"
                       class=" item  p-h-5"
                       v-for="(item,index) in dataList"
            >
              <div :class="{'item-selected':item.isSelected}"
                   @click="itemClick(item,index)"
                   class="m-h-5 m-t-5 p-1 shadow"
                   style="position: absolute;width:  calc(100% - 10px);height: calc(100% - 10px)">
                <!--                  <ratio-div :radio-value="75">-->
                <div class="w-full h-full" style="display: flex;flex-direction: column">
                  <ratio-div :radio-value="75" class="w-full">
                    <img
                      :src="!item.url?require('../../../assets/common/ic_wutu@2x.png'):$getFomatUrl(item.url,500)"
                      @click="preview(item)"
                      class="w-full h-full absolute"
                      style="object-fit: cover"/>
                  </ratio-div>
                  <div class="lin2 m-h-5 m-t-5" style="max-height: 40px">
                    {{ item.title }}
                  </div>
                </div>

                <!--                  </ratio-div>-->

                <!--鼠标悬停编辑-->
                <div class="flex a-center j-center item-editable w-full h-full"
                     style="position: absolute;top: 0;bottom: 0;left: 0;right: 0;background-color: #00000022">
                  <div @click.stop="preview(item)"
                       class="w-30 h-30 b-round flex a-center j-center"
                       style="background-color: #00000099;cursor: pointer;">
                    <img class="w-15 h-15" src="../../../assets/common/ic-preview@2x.png"/>
                  </div>
                  <div @click.stop="toEditPic(item)"
                       class="w-30 h-30 b-round flex a-center j-center  m-l-15"
                       style="background-color: #00000099;cursor: pointer;">
                    <img class="w-15 h-15" src="../../../assets/common/ic-edit@2x.png"/>
                  </div>
                  <div @click.stop="delItem(item)"
                       class="w-30 h-30 b-round flex a-center j-center m-l-15"
                       style="background-color: #00000099;cursor: pointer;">
                    <img class="w-15 h-15" src="../../../assets/common/ic-delete@2x.png"/>
                  </div>
                </div>
                <!--鼠标悬停三角-->
                <div class="triangle" style="position: absolute;top: 0;right: 0;"
                     v-if="item.isSelected">
                </div>
                <!--鼠标悬停对号-->
                <img class="w-16 h-16" src="../../../assets/common/ic-right@2x.png"
                     style="position: absolute;top: 0;right: 0;"
                     v-if="item.isSelected">

                <!--                <div class="fs-12 m-h-15 m-t-5">{{ item.clazz + ' / ' + item.group }}</div>-->
              </div>
            </ratio-div>
            <!--            <div :key="index" @click="itemClick(item,index)"-->
            <!--                 v-for="(item,index) in dataList"-->
            <!--                 class="m-l-10 m-b-10 item border b-2 h-full"-->
            <!--                 :class="{'item-selected':item.isSelected}">-->

            <!--            </div>-->

          </div>

          <div class="m-l-25" style="padding: 10px 0">
            <Page :current.sync="tablePage.currentPage" :page-size="tablePage.pageSize"
                  :show-total="true"
                  :total="tablePage.total" @on-change="onPageChange"
                  @on-page-size-change="onPageSizeChange"
            ></Page>
          </div>
        </div>
      </div>
    </div>

    <!--图片预览-->
    <Modal :closable="true" class="modal-setting" class-name="vertical-center-modal" footer-hide
           title=""
           v-model="previewModal.show"
           width="650">
      <p class="text-center" slot="header">
        <span>{{ previewModal.title }}</span>
      </p>
      <div class="p-h-10 p-b-10 o-y-auto"
           style="min-height: 200px;max-height: 600px">
        <img :onerror="loadImgError"
             :src="previewModal.picUrl?previewModal.picUrl:require('../../../assets/common/ic_wutu@2x.png')"
             style="width: 100%">
      </div>
    </Modal>

    <!--分类管理-->
    <Modal :closable="false" class="modal-setting" class-name="vertical-center-modal"
           v-model="groupManager.show"
           width="640px">
      <p class="text-center" slot="header">
        <span>{{ groupManager.title }}</span>
      </p>
      <div class="flex a-center j-center" style="width: 600px;height: 460px">
        <class-group-setting-widget2 :objInfo="objInfo"
                                     :srcType="6"
                                     class="w-full h-full">
        </class-group-setting-widget2>
      </div>
    </Modal>

    <!--批量上传-->
    <Modal :closable="false" :mask-closable="false" @on-visible-change="onModalClose"
           class="prewmodal"
           class-name="vertical-center-modal" footer-hide
           v-model="showPicUpload"
           width="720">
      <mulite-upload-pic-widget :editData="editData" @cancel="showPicUpload=false"
                                @ok="onUploadOK"></mulite-upload-pic-widget>
    </Modal>


    <Modal :closable="false" :mask-closable="false" class="prewmodal"
           class-name="vertical-center-modal" footer-hide
           v-model="showUploadProgress"
           width="720">
      <div class="p-h-20 p-b-20">
        <div class="h-40 flex a-center j-center">
          上传进度 <span>{{ uploadProgressInfo.finishnum }}</span> /
          <span>{{ uploadProgressInfo.totalnum }}</span>
        </div>
        <Progress :percent="uploadProgressInfo.percent" :stroke-width="20" text-inside/>
      </div>
    </Modal>
    <upload-edit-pic-widget
      ref="uploadEditPicWidget"
      :onOk="getPicListData"
    />
  </base-page-component>
</template>

<script>
import BasePageComponent from '@/components/common/BasePageComponent'
import classGroupSettingWidget2 from '@/components/common/ClassGroupSettingWidget2'
import {mapActions} from 'vuex'
import ClassChooseWidget from '../../../components/common/ClassChooseWidget'
import mixin from '../../../config/mixinfile'
import MuliteUploadPicWidget from './component/MuliteUploadPicWidget'
import UpLoadImage from '../../../components/common/UpLoadImage'
import RatioDiv from '@/components/common/RatioDiv'
import UploadEditPicWidget from '@/views/material/picture/component/UploadEditPicWidget'

export default {
  name: 'PictureRepository2',
  mixins: [mixin.mixin],
  components: {
    UploadEditPicWidget,
    RatioDiv,
    UpLoadImage,
    MuliteUploadPicWidget,
    ClassChooseWidget,
    BasePageComponent,
    classGroupSettingWidget2
  },
  watch: {},
  data () {
    return {
      title: '',                                 //搜索字段
      objChange: {                               //分类分组帅选
        classId: 0,
        groupId: 0,
        linkurl: 'https://goodsmanual.laodao.co/img/materialImgCategory.html?contentType=61&id=0'
      },
      tableHeight: 620,                          //表格高度

      tablePage: {                               //表格分页
        total: 0,
        currentPage: 1,
        pageSize: 70,
      },


      objInfo: {                                 //设置分类分组管理的结构
        classId: 0,
        className: '',
        groupId: 0,
        groupName: '',
        init: false
      },

      groupManager: {
        title: '分类管理',
        show: false,
      },

      columns: [
        {
          type: 'selection',
          width: 55,
          align: 'center'
        }, {
          title: '分类',
          key: 'categoryName',
          width: 110,
          tooltip: true,
          align: 'center'
        }, {
          title: '分组',
          key: 'groupName',
          tooltip: true,
          width: 110,
          align: 'center'
        }, {
          title: '图片标题',
          key: 'title',
          minWidth: 450,
          tooltip: true,
        }, {
          title: '预览',
          slot: 'preview',
          align: 'center',
          width: 96,
        }, {
          //   title: '图片链接',
          //   key: 'linkurl',
          //   minWidth: 400,
          //   align: 'center',
          //   tooltip: true,
          // }, {
          //   title: '复制',
          //   slot: 'copy',
          //   width: 100,
          //   align: 'left'
          // }, {
          title: '操作',
          slot: 'operation',
          width: 150,
          align: 'center',
        }],
      dataList: [],
      previewModal: {
        title: '',
        show: false,
        picUrl: '',
      },
      loadImgError: 'this.src="' + require('../../../assets/common/ic_wutu@2x.png') + '"',

      showPicUpload: false,                         //显示批量上传页面
      editData: {
        objChange: {                                //分类分组帅选
          classId: 0,
          groupId: 0,
          init: false
        },
        picList: []
      },
      showUploadProgress: false,                    //上传进度弹框
      uploadProgressInfo: {
        finishnum: 0,
        totalnum: 0,
        percent: 0
      },

      dCGInfo: {
        classId: 0,
        groupId: 0
      },

      // 选中项
      maps: new Map(),
    }
  },
  mounted () {
    this.init()
  },
  activated () {
    this.setTableHeight()
    this.getPicListData()
  },
  methods: {
    init () {
      this.setTableHeight()
      this.getPicListData()
      this.getDefaultCGInfo()
    },
    setTableHeight(){
      this.tableHeight = window.innerHeight - 250
      window.onresize = () => {
        this.tableHeight = window.innerHeight - 250
      }
    },
    async getDefaultCGInfo () {
      let params = {
        type: 6
      }
      let result = await this.getCategoryLists(params)
      if (result.code === 0) {
        let item = result.data.find(e => {
          return e.isDefault === 1
        })
        if (item && item.id) {
          this.dCGInfo.classId = item.id
          let p = {
            categoryId: item.id,
            type: 6
          }
          let res = await this.getGroupLists(p)
          if (res.code === 0) {
            let itemInfo = res.data.find(e => {
              return e.isDefault === 1
            })
            if (itemInfo && itemInfo.id) {
              this.dCGInfo.groupId = itemInfo.id
            }
          }
        }
      }
    },
    /**
     * 跳转上传新增图片
     * */
    toUpload () {
      // this.$router.push('/Uploadpic')
      this.$refs.uploadEditPicWidget.showUpload()
    },

    /**
     *
     *删除某条图片
     * */
    delItem (row) {
      const content = '<p>确定要删除 ' + row.title + ' 吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          let params = {
            idList: row.imgId
          }
          this.delPic(params).then(res => {
            //如果选中要移除
            this.maps.delete(row.imgId)
            this.getPicListData()
            this.$Message.success('删除成功。')
          })
        },
        onCancel: () => {
        }
      })
    },
    copy (e) {
      this.$Message.info('复制成功')
    },
    onError (e) {
      this.$Message.info('复制失败')
    },
    itemClick (item, index) {
      item.isSelected = !item.isSelected
      if (item.isSelected)
        this.maps.set(item.imgId, item)
      else
        this.maps.delete(item.imgId)
    },

    /**
     * 批量删除(此种实现仅限页面内选择)
     * */
    delMulti () {
      if (this.maps.size === 0) {
        this.$Message.info('没有选中图片')
        return
      }
      const content = '<p>确定要删除吗?</p>'
      this.$Modal.confirm({
        title: '提示',
        content: content,
        onOk: () => {
          let ids = ''
          this.maps.forEach((value, key) => {
            ids += key + ','
          })
          ids = ids.substring(0, ids.length - 1)
          let params = {
            idList: ids
          }
          this.delPic(params).then(res => {
            this.maps.clear()
            this.getPicListData()
            this.$Message.success('删除成功。')
          })
        },
        onCancel: () => {
        }
      })
    },

    /**
     * 跳转编辑
     * */
    toEditPic (row) {
      // this.$router.push({
      //   path: '/editPic',
      //   query: {
      //     imgId: row.imgId
      //   }
      // })
      this.$refs.uploadEditPicWidget.showEdit(row.imgId)
    },
    /**
     * 获取图片列表数据
     */
    getPicListData () {
      let params = {
        pageSize: this.tablePage.pageSize,
        pageNum: this.tablePage.currentPage
      }
      if (this.title) {
        params.title = this.title
      }
      if (this.objChange && this.objChange.classId) {
        params.categoryId = this.objChange.classId
      }
      if (this.objChange && this.objChange.groupId) {
        params.groupId = this.objChange.groupId
      }
      this.getPicLists(params).then(res => {
        if (res.code === 0) {
          this.dataList = res.data.list.map(child => {
            child.linkurl = child.jumpLink ? child.jumpLink.link || '' : ''
            if (this.maps.has(child.imgId))
              this.$set(child, 'isSelected', true)
            else
              this.$set(child, 'isSelected', false)
            return child
          })
          this.tablePage.total = res.data.total
        }
      })
    },

    /**
     * 分页请求
     * @param e
     */
    onPageChange (e) {
      this.tablePage.currentPage = e
      this.dataList.splice(0, this.dataList.length - 1)
      this.getPicListData()
    },
    /**
     * 换页条数请求处理
     * @param e
     */
    onPageSizeChange (e) {
      this.tablePage.pageSize = e
      if (this.tablePage.currentPage === 1) {
        this.getPicListData()
      }
    },
    /**
     * 分类分组筛选
     * @param e
     */
    onClassGroupChange (e) {
      this.objChange = e
      if (!this.objChange.linkurl) {
        this.objChange.linkurl = 'https://goodsmanual.laodao.co/img/materialImgCategory.html?contentType=61&id=0'
      }
      this.tablePage.currentPage = 1
      this.getPicListData()
    },
    /**
     * 输入搜索筛选
     */
    onSearchClick () {
      this.tablePage.currentPage = 1
      this.getPicListData()
    },

    /**
     * 图片预览
     * @param row
     */
    preview (row) {
      this.previewModal.title = row.title
      this.previewModal.picUrl = row.url
      this.previewModal.show = true
    },
    uploadCoverImageStart (progressdata) {
      this.uploadProgressInfo.finishnum = progressdata.finshnum || 0
      this.uploadProgressInfo.totalnum = progressdata.totalnum || 1
      this.uploadProgressInfo.percent = this.uploadProgressInfo.totalnum > 0 ? parseInt(this.uploadProgressInfo.finishnum * 100 / this.uploadProgressInfo.totalnum) : 0
      this.showUploadProgress = true
    },
    uploadCoverImageProgress (progressdata) {
      this.uploadProgressInfo.finishnum = progressdata.finshnum || 0
      this.uploadProgressInfo.totalnum = progressdata.totalnum || 1
      this.uploadProgressInfo.percent = this.uploadProgressInfo.totalnum > 0 ? parseInt(this.uploadProgressInfo.finishnum * 100 / this.uploadProgressInfo.totalnum) : 0
    },
    uploadCoverImageSuccess (data) {
      this.showUploadProgress = false
      this.uploadProgressInfo = {
        finishnum: 0,
        totalnum: 0,
        percent: 0
      }
      if (data && data.length) {
        if (this.dCGInfo.classId) {
          this.editData = {
            objChange: {                               //分类分组帅选
              classId: this.dCGInfo.classId,
              groupId: this.dCGInfo.groupId || 0,
              init: true
            },
            picList: data
          }
        } else {
          this.editData = {
            objChange: {                               //分类分组帅选
              classId: 0,
              groupId: 0,
              init: false
            },
            picList: data
          }
        }
        this.showPicUpload = true
      }
    },
    onModalClose (status) {
      if (!status) {
        this.editData = {
          objChange: {                                //分类分组帅选
            classId: 0,
            groupId: 0,
            init: false
          },
          picList: []
        }
      }
    },
    onUploadOK () {
      this.showPicUpload = false
      this.getPicListData()
    },
    ...mapActions([
      'getPicLists',
      'delPic',
      'getCategoryLists',
      'getGroupLists'
    ])
  }
}
</script>
<style scoped>
  .prewmodal >>> .ivu-modal-body {
    padding: 0;
  }

  .list-container {
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-content: flex-start;
    flex-wrap: wrap;
    /*overflow: auto;*/
  }

  .item {
    /*width: 14.2%;*/
    width: 14.2%;;
    /*height: 220px;*/
    flex-direction: row;
    margin-bottom: 10px;
  }

  .shadow {
    box-shadow: 0 2px 7px rgb(0 0 0 / 15%);
  }

  .item-selected {
    border: 1px solid #0EA4FB;
  }

  .item-editable {
    display: none;
  }

  .item:hover .item-editable {
    display: flex;
  }

  .lin2 {
    /*font-size: 14px;*/
    height: 28px;
    line-height: 14px;
    word-break: break-all;
    text-overflow: ellipsis;
    display: -webkit-box; /** 对象作为伸缩盒子模型显示 **/
    -webkit-box-orient: vertical; /** 设置或检索伸缩盒对象的子元素的排列方式 **/
    -webkit-line-clamp: 2; /** 显示的行数 **/
    overflow: hidden; /** 隐藏超出的内容 **/
  }

  .triangle {
    width: 0;
    height: 0;
    border-color: transparent #0F8CFB;
    border-width: 0 25px 25px 0;
    border-style: solid;
  }

</style>
